/** 学生页「行规分」面板:总分、系数、记录列表、加减分。 */
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useConductConfig, useConductMutations, useStudentConduct } from "../../api/gpa";
import { ConductModal } from "./ClassConductPage";

export function ConductPanel({ studentId, studentName }: { studentId: string; studentName: string }): JSX.Element | null {
  const { t } = useTranslation();
  const d = useStudentConduct(studentId);
  const cfg = useConductConfig();
  const m = useConductMutations();
  const [open, setOpen] = useState(false);
  if (!d.data) return null;
  const c = d.data;
  return (
    <section className="mb-6 rounded-lg border border-slate-200 bg-white p-6" data-testid="conduct-panel">
      <div className="mb-3 flex flex-wrap items-baseline justify-between gap-2">
        <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-600">{t("gpa.conduct.title")}</h2>
        <div className="flex items-center gap-4 text-sm">
          <span>{t("gpa.conduct.total")}: <b>{c.total}</b> <span className="text-xs text-slate-400">({c.base_score} {c.plus ? `+${c.plus}` : ""} {c.minus || ""})</span></span>
          <span>{t("gpa.conduct.coefficient")}: <b className={c.coefficient >= 1 ? "text-emerald-700" : "text-amber-700"}>× {c.coefficient.toFixed(2)}</b></span>
          <button type="button" onClick={() => setOpen(true)} className="rounded bg-sky-500 px-2.5 py-1 text-xs font-medium text-white hover:bg-sky-600">{t("gpa.conduct.add")}</button>
        </div>
      </div>
      {c.records.length === 0 ? <p className="text-xs text-slate-400">{t("gpa.conduct.noRecords")}</p> : (
        <ul className="divide-y divide-slate-100 text-sm">
          {c.records.map((r) => (
            <li key={r.id} className="flex items-center gap-3 py-1.5">
              <span className="w-24 shrink-0 text-xs text-slate-500">{r.recorded_on}</span>
              <span className={`w-12 shrink-0 text-right font-medium ${r.points >= 0 ? "text-emerald-700" : "text-rose-600"}`}>{r.points > 0 ? `+${r.points}` : r.points}</span>
              <span className="min-w-0 flex-1 truncate text-slate-700">{r.category}{r.item ? ` · ${r.item}` : ""}{r.note ? <span className="ml-1 text-slate-400">— {r.note}</span> : null}</span>
              <span className="text-xs text-slate-400">{r.teacher_name ?? (r.source === "import" ? t("gpa.conduct.imported") : "")}</span>
              <button type="button" onClick={() => m.remove.mutate(r.id)} className="text-xs text-rose-500 hover:underline">{t("common.delete")}</button>
            </li>
          ))}
        </ul>
      )}
      {open && cfg.data && (
        <ConductModal student={{ name_zh: studentName }} categories={cfg.data.categories} onClose={() => setOpen(false)}
          onSave={async (r) => { await m.add.mutateAsync({ ...r, student_id: studentId }); setOpen(false); }} />
      )}
    </section>
  );
}
